export default {
  "hvac-1n3jw": "North America Equipments",
  "equipements-france": "France Equipments",
  equipment_type:{
    "membrane_flashing": "Relevé d'étanchéité",
    "equipment_base": "Costière",
    "insulated_parapet": "Isolant en relevé",
    "metal_flashing": "Bande Soline / engravure",
    "cap_metal_flashing": "Couvertine / entablement",
    "drain": "Naissance EP",
    "overflow": "Trop plein",
    "vault": "Voute",
    "skylight": "Lanterneau",
    "fix_skylight": "Lanterneau",
    "opening_skylight": "Lanterneau ouvrant",
    "double_opening_skylight": "Lanterneau double-ouvrant",
    "counter_cladding": "Contre-bardage",
    "safety_post": "Potelet de sécurité",
    "safety_cable": "Ligne de vie",
    "guard_rail": "Garde-corps",
    "goose_neck": "Crosse",
    "water_lock": "Boite à eau",
    "ventilation": "Ventilation EU/EV",
    "slope": "Pente",
    "rooftop": "Rooftop",
    "smoke_conduct": "Conduit de fumée",
    "motor_and_equipment": "Moteur & équipement",
    "single_expansion_joint": "Joint de dilatation simple",
    "double_expansion_joint": "Joint de dilatation double",
    "gravel_stop": "Bande pare gravier",
    "edge_strip_sewer": "Bande de rive/égout",
    "drip_gutter": "Bande pare-gravier",
    "generic_object": "Objet générique",
    "drip": "Chéneau / Gouttière",
    "motor_equipment": "Moteur & équipement",
  },
  menu: {
    roof_section: "Section de toiture",
    equipments: "Equipements",
    projects: "Projets",
    new_project: "Nouveau projet",
    project_list: "Liste de projets",
    add_roof_section: "Ajouter section de toiture",
    filters: "filtre",
    add_project: "ajouter un projet",
    unit_scale: "Echelle",
    add_equipment: "Ajouter un équipement",
    add_note: "Ajouter une note",
    assets: "Plan (1/3)",
    hand: "Main",
    help: "Aide",
    placeholder: {
      search: "Rechercher",
      unit_scale: "Echelle",
    },
    copy: "Copie",
    back: "Précédent",
    properties: "Propriétés",
    assign_divlato_code: "Code Divalto",
  },
  modal: {
    help: {
      zoom: `Utiliser <code>la souris</code> pour zoomer / dézoomer`,
      drag: `Utiliser <code>la souris</code> pour vous déplacer sur le plan`,
      esc: `Appuyer sur <code>Echap pour</code> arrêter de dessiner un polygone`
    }
  },
  sidebar: {
    titles: {
      roof_section: "Section de toiture",
      equipment: "équipement",
      equipment_details: "Détails équipement",
      added_equipment: "équipements ajoutés",
      assets_list: "liste des plans",
      identification: "configuration de l'identification automatique",
      section_details: "détails de l'équipement",
      roof_details: "Détails du toit",
      project_settings: 'Paramètres du projet',
      project_group_threshold: "Grouper les équipements",
      threshold_definition: "Grouper les équipements similaires dont les dimensions sont différentes de moins de"
    },
    label: {  
      roof_sections: "Roof Sections",      
      added_equipments: "Equipement ajouté",
      filter: "Filtrer",
      total_perimeter: "Total relevés périphériques",
      draggable: "Déplacer",
      auto_set_shape: "Reformer",
      perimeter: "Relevés périphériques",
    },
    heading: {
      label: "Nom",
      perimeter: "Périmètre",
      area: "Surface brute",
      net_area:"Surface nette",
      equip_count: "Nombre d'équipe.",
      action: "Action",
      icon: "Icône",
      equipment: "Equipement",
      utilities: "Fonctionnalités",
      width: "Largeur",
      length: "Longueur",
      skylight_type: "Type de lanterneau",
      height: "Hauteur",
      ply_count: "Nombre de plis",
      nature: "Nature",
      drawing_type: "Type",
      flashing_type: "Type",
      kind: "Type",
      shape: "Forme",
      other: "Autre",
      flashing: "Solin",
      engraving: "Engravure",
      cover: "Couvertine",
      entablature: "Entablement",
      vertical: "Verticale",
      horizontal: "Horizontale",
      diameter: "Diamètre",
      rectangular: "Rectangle",
      cylindrical: "Cylindrique",
      quantity: "Quantité",
      report_on_roof_sections_and_equipment: "Rapport des toitures & équipements",
    },
    placeholder: {
      search: "Rechercher"
    }
  },
  project_headings:{
    name: "Nom du projet",
    address: "Adresse",
    asset_type: "type d'actif",
    asset_status: "état des actifs",
    scale: "échelle",
    created_at: "Créé à"
  },
  project_status: {
    ready: "prêt",
    pending: "en attente",
    draft: "brouillon",
    uploaded: "téléchargé",
    set: "Fait",
    notset: "pas encore défini"
  },
  project_form: {
    labels: {
      pdf: "Nouveau projet PDF",
      drone: "Nouveau projet drone",
      using: "Utilisez-vous",
      name_field: "Nom du projet",
      date_field: "Date d'inspection",
      agency_field: "Assigner une agence",
      client_field: "Société client",
      address_field: "Adresse",
      heading: "Détails du projet"
    },
    placeholder: {
      name_field: "Entrer le nom d'un nouveau projet",
      client_field: "Choisir un client",
      address_field: "Rechercher sur Google Maps"
    },
    
  },
  errors: {
    required: "Requis"
  },
  upload_form: {
    dnd_pdf: "Déposer PDF ",
    dnd_zip: "Déposer ZIP avec ortho-image & images drone"
  },
  table_headings: {
    name: "Nom",
    shape_type: "Type de forme",
    color: "Couleur"
  },
  general: {
    or: "ou",
    new: "nouveau",
    cancel: "Annuler",
    save: "Sauvegarder",
    home: "page d'accueil"
  },
  warnings: {
    reset_project_analysis: "Attention, vous avez déjà utilisé la détection IA sur ce projet, si vous recliquez sans avoir supprimé les premiers équipements, des doublons vont apparaitre.",
    roof_creation_info_text: "Attention, en traçant une section de toiture après la détection par IA des équipements, il se peut que ces derniers n'apparaissent qu'au bout de 1 à 2 minutes comme appartenant à cette toiture dans le menu 'roof section menu LOGO'"
  },
  grouping: {
    title: "Grouper les équipements",
    ruleName: "Nom de la règle",
    minPerimeter: "Périmètre minimum",
    maxPerimeter: "Périmètre maximum",
    addRule: "Ajouter une règle",
    generateReport: "Générer le rapport",
    note: "Les règles modifiées ici sont temporaires et ne seront pas enregistrées de façon permanente.",
    noRulesFound: "Aucune règle trouvée."
  }
}
